import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'EMAIL_KEY',
    stateKey: 'email',
    validateOnChange: true,
  },
  {
    gridXs: 12,
    label: 'PASSWORD_KEY',
    stateKey: 'password',
    isPassword: true,
    validateOnChange: true,
  },
];

export default fields;
